import { useTranslation } from 'react-i18next';
import FormHeader from '../../../../common/FormHeader';
import HelpModal from '../../../../common/HelpModal';
import BackButton from '../BackButton';
import SignUpClosedNotice from '../../../../common/SignUpClosedNotice';
import { signUpEnabled } from '../../../../../context/GlobalContext';

const TeamOptions = ({ firstName, onShowJoinTeam, onShowCreateTeam, onGoBack }) => {
  const { t } = useTranslation();

  return (
    <div className="form-signup">
      <BackButton handler={onGoBack} />
      <FormHeader title={t('auth.teamOptionsTitle', { name: firstName })} />
      <SignUpClosedNotice />
      <button onClick={onShowJoinTeam} className="mg-btn mg-btn--primary mg-btn--block mg-mb-2">
        {t('auth.joinATeam')}
      </button>
      <button
        onClick={onShowCreateTeam}
        className="mg-btn mg-btn--primary mg-btn--block mg-mb-2"
        disabled={!signUpEnabled}
      >
        {t('auth.createATeam')}
      </button>

      <div className="mg-text-center">
        <span>{t('auth.notSure')} </span>
        <HelpModal
          title={t('auth.joinOrCreateTitle')}
          description={[t('auth.joinOrCreateHelp1'), t('auth.joinOrCreateHelp2')]}
        >
          {t('auth.learnMore')}
        </HelpModal>
      </div>
    </div>
  );
};

export default TeamOptions;
